import axios from 'axios'
import { Message } from 'view-design'
class HttpRequest {
  constructor () {
    // 构造函数
  }
  getInsideConfig () {
    const config = {
      baseURL: `${window.config.baseUrl}api`,
      headers: {
        // 一些请求头信息配置
      }
    }
    return config
  }
  interceptors (instance, options) {
    // 添加请求拦截器
    instance.interceptors.request.use(config => {
      // 在发送请求之前做些什么
      return config
    }, error => {
      // 对请求错误做些什么
      return Promise.reject(error)
    })
    // 添加响应拦截器
    instance.interceptors.response.use(response => {
      // 对响应数据做点什么
      const { data, status } = response
      return { data, status }
    }, error => {
      // 对响应错误做点什么
      Message.error({
        content: '系统错误',
        closable: true,
        duration: 10
      })
      return Promise.reject(error)
    })
  }
  request (options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    if (options.method === 'get') {
      let url = []
      Object.keys(options.data).map(key => url.push(`${key}=${options.data[key]}`))
      options.url = `${options.url}?${url.join('&')}`
    }
    this.interceptors(instance, options)
    return instance(options)
  }
}
export default HttpRequest